import axios from 'axios';
import {
    ALL_USER_FAILURE,
    ALL_USER_REQUEST,
    ALL_USER_SUCCESS,
    CLEAR_ERRORS,
    DELETE_USER_FAILURE,
    DELETE_USER_REQUEST,
    DELETE_USER_SUCCESS,
    FORGOT_PASSWORD_FAILURE,
    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_SUCCESS,
    LOAD_USER_FAILURE,
    LOAD_USER_REQUEST,
    LOAD_USER_SUCCESS,
    LOGIN_FAILURE,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGOUT_USER_FAILURE,
    LOGOUT_USER_SUCCESS,
    REGISTER_USER_FAILURE,
    REGISTER_USER_REQUEST,
    REGISTER_USER_SUCCESS,
    RESET_PASSWORD_FAILURE,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    UPDATE_PASSWORD_FAILURE,
    UPDATE_PASSWORD_REQUEST,
    UPDATE_PASSWORD_SUCCESS,
    UPDATE_PROFILE_FAILURE,
    UPDATE_PROFILE_REQUEST,
    UPDATE_PROFILE_SUCCESS,
    UPDATE_USER_FAILURE,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    USER_DETAILS_FAILURE,
    USER_DETAILS_REQUEST,
    USER_DETAILS_SUCCESS,
} from '../constants/userConstants';
import { URL } from '../../Routing';
import Cookies from 'universal-cookie';

const getHeader = () => {
    return { headers: { Authorization: new Cookies().get('token') } };
};

export const login = (loginData) => async (dispatch) => {
    dispatch({ type: LOGIN_REQUEST });
    try {
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        const { data } = await axios.post(`${URL}/api/v1/login`, loginData, config);
        dispatch({
            type: LOGIN_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: LOGIN_FAILURE,
            payload: error?.response?.data.error,
        });
    }
};

export const register = (loginData) => async (dispatch) => {
    dispatch({ type: REGISTER_USER_REQUEST });
    try {
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        const { data } = await axios.post(`${URL}/api/v1/register`, loginData, config);
        dispatch({
            type: REGISTER_USER_SUCCESS,
            payload: data.user,
        });
    } catch (error) {
        dispatch({
            type: REGISTER_USER_FAILURE,
            payload: error?.response?.data.error,
        });
    }
};

export const loadUser = () => async (dispatch) => {
    dispatch({ type: LOAD_USER_REQUEST });
    try {
        const { data } = await axios.get(`${URL}/api/v1/me`, getHeader());
        dispatch({
            type: LOAD_USER_SUCCESS,
            payload: data.user,
        });
    } catch (error) {
        dispatch({
            type: LOAD_USER_FAILURE,
            payload: error?.response?.data.error,
        });
    }
};

export const logout = () => async (dispatch) => {
    try {
        await axios.get(`${URL}/api/v1/logout`, getHeader());
        dispatch({
            type: LOGOUT_USER_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: LOGOUT_USER_FAILURE,
            payload: error.response.data.error,
        });
    }
};

//  Update Profile
export const updateProfile = (userData) => async (dispatch) => {
    dispatch({ type: UPDATE_PROFILE_REQUEST });
    try {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: new Cookies().get('token'),
            },
        };
        const data = await axios.put(`${URL}/api/v1/me/update`, userData, config);
        dispatch({
            type: UPDATE_PROFILE_SUCCESS,
            payload: data.data.success,
        });
    } catch (error) {
        dispatch({
            type: UPDATE_PROFILE_FAILURE,
            payload: error.response.data.error,
        });
    }
};

//  Change Password
export const changePassword = (passwordObj) => async (dispatch) => {
    dispatch({ type: UPDATE_PASSWORD_REQUEST });
    try {
        // const config = { headers: { 'Content-Type': 'application/json' } };
        const data = await axios.put(`${URL}/api/v1/password/update`, getHeader(), passwordObj);
        dispatch({
            type: UPDATE_PASSWORD_SUCCESS,
            payload: data.data.user,
        });
    } catch (error) {
        dispatch({
            type: UPDATE_PASSWORD_FAILURE,
            payload: error.response.data.error,
        });
    }
};

//  Forgot Password
export const forgotPassword = (email) => async (dispatch) => {
    dispatch({ type: FORGOT_PASSWORD_REQUEST });
    try {
        // const config = { headers: { 'Content-Type': 'application/json' } };
        const data = await axios.post(`${URL}/api/v1/password/forgot`, email, getHeader());
        dispatch({
            type: FORGOT_PASSWORD_SUCCESS,
            payload: data.data.message,
        });
    } catch (error) {
        dispatch({
            type: FORGOT_PASSWORD_FAILURE,
            payload: error.response.data.error,
        });
    }
};

//  Reset Password
export const resetPassword = (token, passwords) => async (dispatch) => {
    dispatch({ type: RESET_PASSWORD_REQUEST });
    try {
        // const config = { headers: { 'Content-Type': 'application/json' } };
        const data = await axios.put(
            `${URL}/api/v1/password/reset/${token}`,
            getHeader(),
            passwords
        );
        dispatch({
            type: RESET_PASSWORD_SUCCESS,
            payload: data.data.success,
        });
    } catch (error) {
        dispatch({
            type: RESET_PASSWORD_FAILURE,
            payload: error.response.data.error,
        });
    }
};

// Admin actions -------
export const getAllUsers = () => async (dispatch) => {
    dispatch({ type: ALL_USER_REQUEST });
    try {
        const { data } = await axios.get(`${URL}/api/v1/admin/users`, getHeader());
        dispatch({
            type: ALL_USER_SUCCESS,
            payload: data.users,
        });
    } catch (error) {
        dispatch({
            type: ALL_USER_FAILURE,
            payload: error.response.data.error,
        });
    }
};

export const getUserDetails = (id) => async (dispatch) => {
    dispatch({ type: USER_DETAILS_REQUEST });
    try {
        const { data } = await axios.get(`${URL}/api/v1/admin/user/${id}`, getHeader());
        dispatch({
            type: USER_DETAILS_SUCCESS,
            payload: data.user,
        });
    } catch (error) {
        dispatch({
            type: USER_DETAILS_FAILURE,
            payload: error.response.data.error,
        });
    }
};

export const updateUser = (id, userData) => async (dispatch) => {
    dispatch({ type: UPDATE_USER_REQUEST });
    try {
        // const config = { headers: { 'Content-Type': 'application/json' } };
        const { data } = await axios.put(`${URL}/api/v1/admin/user/${id}`, getHeader(), userData);
        dispatch({
            type: UPDATE_USER_SUCCESS,
            payload: data.success,
        });
    } catch (error) {
        dispatch({
            type: UPDATE_USER_FAILURE,
            payload: error.response.data.error,
        });
    }
};

export const deleteUser = (id) => async (dispatch) => {
    dispatch({ type: DELETE_USER_REQUEST });
    try {
        // const config = { headers: { 'Content-Type': 'application/json' } };
        const { data } = await axios.delete(`${URL}/api/v1/admin/user/${id}`, getHeader());
        dispatch({
            type: DELETE_USER_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: DELETE_USER_FAILURE,
            payload: error.response.data.error,
        });
    }
};

export const clearErrors = () => async (dispatch) => {
    dispatch({
        type: CLEAR_ERRORS,
    });
};
